<template>
    <div class="col-span-12 gap-4">

        <input-text class="col-span-12" type="date" v-model="startDate">
            <span v-show="timeSelectionMode !== 'multi-day'">Datum</span>
            <span v-show="timeSelectionMode === 'multi-day'">Von</span>
        </input-text>

        <time-select v-if="timeSelectionMode !== 'multi-day'"
                     class="col-span-12"
                     :has-half-steps="hasHalfSteps"
                     v-model="time"
                     :time_selection_mode="timeSelectionMode"
        ></time-select>

        <input-text class="col-span-12" type="date" v-model="endDate" v-show="timeSelectionMode === 'multi-day'">
            Bis
        </input-text>

        <div v-if="hasRepeating" class="grid gap-6">
            <div class="mt-10 col-span-12 sm:col-span-3">
                <label class="flex">
                    <input class="mr-2 mt-1" type="checkbox" v-model="isSeries">
                    <span v-if="!isSeries">Wiederholen</span><span v-if="isSeries">Wiederholen alle</span>
                </label>
            </div>

            <div class="mt-auto col-span-12 sm:col-span-2" v-if="isSeries">
                <input-text :has-error="!!everyError" class="col-span-6 justify-self-end" v-model="every" type="number"></input-text>
            </div>
            <div class="mt-auto col-span-12 sm:col-span-3" v-if="isSeries">
                <select-menu :values="['daily','weekly','monthly','yearly']"
                             :text="['Tag(e)','Woche(n)','Monat(e)','Jahr(e)']"
                             v-model="repeat">

                </select-menu>
            </div>
            <div class="mt-auto col-span-12 sm:col-span-4" v-if="isSeries">
                <input-text type="date" v-model="until" :has-error="dateError" class="col-span-12">
                    Bis zum
                </input-text>
            </div>

            <div class="mb-4 col-span-12">
                <span v-show="everyError" style="color: red"> {{everyError}}</span>
            </div>

            <div class="mb-4 col-span-12">
                <span v-show="dateError && isSeries" style="color: red"> 'Datum' muss kleiner als 'Bis zum' sein.</span>
            </div>
        </div>

    </div>
</template>

<script>
import InputText from "./UI/InputText.vue";
import TimeSelect from "./TimeSelect.vue";
import SelectMenu from "./UI/SelectMenu.vue";

export default {

    name: "DateTimeRangeSelect",

    components: {
        SelectMenu,
        TimeSelect,
        InputText,
    },

    props: {
        value: {},
        timeSelectionMode: {
            type: String,
            default: 'free', // free or slot
        },
        hasHalfSteps: {
            default: true,
        },
        hasRepeating: {
            type: Boolean,
            default: false,
        }
    },

    data: (vm) => ({
        everyError: null,
        dateError: false,
        isSeries: vm.value.isSeries ?? false,
        every: vm.value.every ?? 1,
        repeat: vm.value.repeat ?? 'daily',
        until: vm.value.until ?? (new Date(new Date().getFullYear(), 11, 31)).toISOString().substr(0, 10),
    }),

    watch: {
        timeSelectionMode(mode) {
            if (mode === 'multi-day') {
                this.startTime = '00:00';
                this.endTime = '23:59';
            }

            if (mode !== 'multi-day') {
                this.endDate = this.startDate;
            }
        },
        startDate(){
            this.validateDates();
        },

        every(val){
            if(val < 1){
                this.everyError = "Wiederholen muss mindestens '1' sein."
            }else{
                this.everyError = null
            }

            this.validateDates();
        },
        until(){
            this.validateDates();
        },
        isSeries(){
            this.validateDates();
        },
        date() {
            this.validateDates();
        },
        repeat() {
            this.validateDates();
        },
    },

    methods: {
        validateDates(){
            this.dateError = this.date >= this.until && this.isSeries;

            this.local = {
                ...this.local,
                isSeries: this.isSeries,
                every: this.every,
                repeat: this.repeat,
                until: this.until,
                error: this.date >= this.until || this.every < 1
            };
        }
    },

    computed: {
        date(){
            let [y, m, d] = this.local.start.substring(0, 10).split('-');
            return `${y}-${m}-${d}`;
        },

        local: {
            set(value) {
                this.$emit('input', value);
            },
            get() {
                return this.value;
            },
        },
        startDate: {
            set(value) {
                this.local.start = value + ' ' + this.startTime;

                if (this.timeSelectionMode !== 'multi-day') {
                    this.endDate = value;
                    return;
                }

                if (this.endDate < value) {
                    this.endDate = value;
                }
            },
            get() {
                return this.local.start.substring(0, 10);
            },
        },
        endDate: {
            set(value) {
                this.local.end = value + ' ' + this.endTime;
                if (this.startDate > value) {
                    this.startDate = value;
                }
            },
            get() {
                return this.local.end.substring(0, 10);
            },
        },
        time: {
            get() {
                return this.startTime + '-' + this.endTime;
            },
            set(value) {
                const [start, end] = value.split('-');
                this.startTime = start;
                this.endTime = end;
            },
        },
        startTime: {
            set(value) {
                if (value.substring(1,2) === ':') {
                    value = '0' + value;
                }
                this.local.start = this.startDate + ' ' + value;
            },
            get() {
                return this.local.start.substring(11, 16);
            },
        },
        endTime: {
            set(value) {
                if (value.substring(1,2) === ':') {
                    value = '0' + value;
                }
                this.local.end = this.endDate + ' ' + value;
            },
            get() {
                return this.local.end.substring(11, 16);
            },
        },
    }

}
</script>

<style scoped>

</style>
